import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AssigneeModalComponent, AssigneeModalData, AssigneeOption, PaginatedResponse } from '../assignee-modal/assignee-modal.component';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';


@Component({
    selector: 'assignee-card',
    templateUrl: './assignee-card.component.html',
    styleUrl: './assignee-card.component.scss',
    standalone: false
})
export class AssigneeCardComponent {
  @Input() label: string = '';
  @Input() value: string = '';
  @Input() isAssigned: boolean = false;
  @Input() isRelatedToCompany: boolean = false;
  @Input() relatedCompanyName: string | null = null;
  @Input() addLink: string | null = null;
  @Input() assigneeObj: { id: number, name: string } = { id: 0, name: '' };
  @Input() assigneeError: string | null = null;
  @Input() dataSource!: (params: { page: number; searchTerm?: string }) => Observable<PaginatedResponse<AssigneeOption>>; // Parent provides pagination fetcher
  
  @Output() assigneeSelected = new EventEmitter<AssigneeOption>();
  @Output() assigneeUnlinked = new EventEmitter<void>();

  assigneeDialogRef: MatDialogRef<AssigneeModalComponent> | null = null;

  constructor(private dialog: MatDialog,
    private router: Router
  ) { }

  openAssigneeModal() {
    if (!this.dataSource) {
      return;
    }

    const data: AssigneeModalData = {
      title: this.label,
      value: this.value,
      assigneeObj: this.assigneeObj,
      fetchData: this.dataSource,
      subtitle: this.isRelatedToCompany && this.relatedCompanyName 
        ? this.relatedCompanyName 
        : undefined
    };
    
    this.assigneeDialogRef = this.dialog.open(AssigneeModalComponent, {
      data,
      disableClose: true,
      panelClass: 'assignee-modal-container'
    });

    this.assigneeDialogRef.afterClosed().subscribe((result: AssigneeOption | null) => {
      if (result) {
        this.assigneeSelected.emit(result);
      }
    });
  }

  unlinkAssignee() {
    this.assigneeUnlinked.emit();
  }

  openInNewTab() {
    const url = this.router.serializeUrl(
      this.router.createUrlTree([this.addLink])
    );
    window.open(url, '_blank');
  }
}
